import { render, staticRenderFns } from "./shiXinBeiZhiXingRen.vue?vue&type=template&id=79556cdb&scoped=true&"
import script from "./shiXinBeiZhiXingRen.vue?vue&type=script&lang=js&"
export * from "./shiXinBeiZhiXingRen.vue?vue&type=script&lang=js&"
import style0 from "./shiXinBeiZhiXingRen.vue?vue&type=style&index=0&id=79556cdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79556cdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/site-front-pipline/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79556cdb')) {
      api.createRecord('79556cdb', component.options)
    } else {
      api.reload('79556cdb', component.options)
    }
    module.hot.accept("./shiXinBeiZhiXingRen.vue?vue&type=template&id=79556cdb&scoped=true&", function () {
      api.rerender('79556cdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/company/shiXinBeiZhiXingRen.vue"
export default component.exports